var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 119,
    viewBox: "0 0 125 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2443_549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.80836 113.394C7.54223 117.061 11.2221 118.636 11.2221 118.636C11.2221 118.636 12.0909 114.264 10.357 110.597C8.62313 106.93 4.94322 105.356 4.94322 105.356C4.94322 105.356 4.07448 109.727 5.80836 113.394Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00007 112.188C10.1304 114.336 11.336 118.602 11.336 118.602C11.336 118.602 7.46632 119.386 4.33596 117.238C1.2056 115.09 0 110.824 0 110.824C0 110.824 3.86971 110.04 7.00007 112.188Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1831 5.71283H57.6519V6.03102H77.1831V5.71283Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8818 5.95148H71.6028V8.89477H71.8818V5.95148Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.3718 5.95148H63.0928V8.89477H63.3718V5.95148Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0881 20.9861H67.5569V21.3043H87.0881V20.9861Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1374 18.1224H72.8584V21.0657H73.1374V18.1224Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6474 18.1224H81.3684V21.0657H81.6474V18.1224Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.037 28.1455H93.5056V28.4637H113.037V28.1455Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0859 25.2817H98.8069V28.225H99.0859V25.2817Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.596 25.2817H107.317V28.225H107.596V25.2817Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.084 101.966H91.5525V102.285H111.084V101.966Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.1328 99.1027H96.8538V102.046H97.1328V99.1027Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.643 99.1027H105.364V102.046H105.643V99.1027Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.7412 50.8964H58.21V51.2146H77.7412V50.8964Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7902 48.0326H63.5112V50.9759H63.7902V48.0326Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3003 48.0326H72.0212V50.9759H72.3003V48.0326Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8796 89.2388H64.3484V89.557H83.8796V89.2388Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9287 86.375H69.6497V89.3183H69.9287V86.375Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4387 86.375H78.1597V89.3183H78.4387V86.375Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.13 77.6246H95.5984V77.9428H115.13V77.6246Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.179 74.7609H100.9V77.7042H101.179V74.7609Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.689 74.7609H109.41V77.7042H109.689V74.7609Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5106 111.715H17.4768V111.444H50.2728V98.2998H20.2539L18.7956 94.8351L19.0099 94.7179L20.4034 98.0287H50.5106V111.715Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8733 118.355C23.2514 118.355 24.3686 117.081 24.3686 115.51C24.3686 113.938 23.2514 112.664 21.8733 112.664C20.4951 112.664 19.3779 113.938 19.3779 115.51C19.3779 117.081 20.4951 118.355 21.8733 118.355Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4705 118.355C47.8486 118.355 48.9658 117.081 48.9658 115.51C48.9658 113.938 47.8486 112.664 46.4705 112.664C45.0923 112.664 43.9751 113.938 43.9751 115.51C43.9751 117.081 45.0923 118.355 46.4705 118.355Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4642 56.8335C76.3173 56.8335 77.0089 56.0448 77.0089 55.0719C77.0089 54.099 76.3173 53.3102 75.4642 53.3102C74.611 53.3102 73.9194 54.099 73.9194 55.0719C73.9194 56.0448 74.611 56.8335 75.4642 56.8335Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0438 93.828H16.9137L8.87964 63.8801H62.3177L62.2691 64.0563L54.0438 93.828ZM17.0895 93.557H53.8695L61.9937 64.1511H9.20084L17.0895 93.557Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1454 92.2696H18.5327L11.4761 65.7095H58.4126L58.3699 65.8659L51.1454 92.2696Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9834 61.2046L62.7537 61.1351L64.3219 54.3943H73.4442V54.6654H64.5048L62.9834 61.2046Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6473 72.9593H11.4758V73.2303H59.6473V72.9593Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8887 82.9442H14.1545V83.2152H56.8887V82.9442Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7167 64.0156H35.479V93.6925H35.7167V64.0156Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3568 64.0071L44.6509 93.6832L44.8881 93.701L46.594 64.0249L46.3568 64.0071Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8439 64.0068L24.6067 64.0244L26.3027 93.7012L26.5399 93.6836L24.8439 64.0068Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 118.527H0V118.845H125V118.527Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0652 9.84428C83.0652 9.84428 85.1046 16.4637 83.8496 17.4821C82.5945 18.5005 88.0852 26.8172 88.0852 26.8172L94.6741 24.7804L91.0659 17.8215C91.0659 17.8215 90.5953 10.8626 90.5953 9.84427C90.5953 8.8259 83.0652 9.84428 83.0652 9.84428Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.0652 9.84428C83.0652 9.84428 85.1046 16.4637 83.8496 17.4821C82.5945 18.5005 88.0852 26.8172 88.0852 26.8172L94.6741 24.7804L91.0659 17.8215C91.0659 17.8215 90.5953 10.8626 90.5953 9.84427C90.5953 8.8259 83.0652 9.84428 83.0652 9.84428Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.642 57.0289C79.642 57.0289 79.0467 65.5154 79.642 69.9283C80.2374 74.3413 81.1304 86.5618 81.1304 86.5618C81.1304 86.5618 81.1304 109.645 84.4047 109.984C87.679 110.324 90.0603 110.663 90.3579 109.305C90.6556 107.948 88.8696 107.269 89.7626 106.59C90.6556 105.911 90.9533 103.535 89.7626 100.819C88.5719 98.1034 89.7626 70.6073 89.7626 70.6073L95.4182 87.9196C95.4182 87.9196 96.0135 102.177 96.6089 104.214C97.2042 106.25 96.0135 109.984 98.0972 110.324C100.181 110.663 102.562 108.627 103.753 107.948C104.943 107.269 101.967 107.269 102.562 106.929C103.157 106.59 104.943 105.571 104.348 105.232C103.753 104.893 103.157 88.5985 103.157 88.5985C103.157 88.5985 101.52 53.8041 99.4367 52.4463C97.353 51.0884 96.0135 53.4272 96.0135 53.4272L79.642 57.0289Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85 108.627V111.342C85 111.342 82.321 118.724 85 118.724C87.679 118.724 89.7626 119.489 89.7626 118.471V109.306L85 108.627Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.562 108.622V111.337C102.562 111.337 105.241 118.719 102.562 118.719C99.8832 118.719 97.7996 119.484 97.7996 118.466V109.301L102.562 108.622Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.2325 14.7664C90.1916 14.7664 92.5904 12.0308 92.5904 8.6562C92.5904 5.28161 90.1916 2.54596 87.2325 2.54596C84.2734 2.54596 81.8745 5.28161 81.8745 8.6562C81.8745 12.0308 84.2734 14.7664 87.2325 14.7664Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5953 20.028C85.5953 20.028 87.0836 25.1199 89.465 24.1015L91.8463 23.0831L96.0136 55.6711C96.0136 55.6711 92.7393 61.1024 87.9766 57.7079C83.214 54.3133 85.5953 20.028 85.5953 20.028Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.7625 19.0096L91.1019 15.7848C91.1019 15.7848 98.99 20.028 100.181 21.3858C101.371 22.7437 101.371 24.7804 101.371 24.7804L99.2877 33.2669C99.2877 33.2669 99.883 51.9371 99.883 52.616C99.883 53.2949 101.967 57.0289 100.478 55.6711C98.99 54.3133 98.6924 52.9555 97.5017 54.9922C96.3111 57.0289 93.6321 59.4052 93.6321 59.4052L89.7625 19.0096Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.181 43.4506L99.2877 52.9554C99.2877 52.9554 93.9297 58.3868 95.1204 58.7262C96.3111 59.0657 96.9064 57.7079 96.9064 57.7079C96.9064 57.7079 98.99 60.0841 100.181 58.7262C101.371 57.3684 104.348 44.469 104.348 44.469L100.181 43.4506Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3465 0.0206621C86.1587 -0.0277623 84.8876 -0.0517161 83.8861 0.678243C83.4253 1.04458 83.0211 1.49576 82.6902 2.01331C81.7148 3.41948 80.872 5.18877 81.2343 6.93344L81.6551 6.74628C81.6551 7.21199 81.5643 7.67187 81.3893 8.09266C81.4486 7.89616 81.647 8.21381 81.5939 8.41258L81.1304 10.1468C81.8924 9.82827 82.8403 10.4733 82.9563 11.3893C83.0093 9.37498 83.1925 7.06514 84.6254 5.88565C85.348 5.29084 86.2625 5.10926 87.1423 4.94801C87.954 4.79926 88.805 4.65741 89.5825 4.96215C90.3599 5.26689 91.022 6.17367 90.8457 7.08942C91.2042 6.94859 91.6052 7.23351 91.7823 7.61581C91.9595 7.9981 91.9688 8.44908 91.9741 8.88143C92.3563 9.18942 92.7912 8.57784 92.9469 8.07463C93.3124 6.89344 93.6374 5.63609 93.4405 4.40379C93.2435 3.17148 92.363 1.99383 91.2646 1.98965C91.3979 1.82265 91.4691 1.60306 91.463 1.37733L90.5576 1.29009C90.7875 1.25298 90.9988 1.1259 91.1555 0.930606C90.7921 1.38673 87.9342 0.0446237 87.3465 0.0206621Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.0836 17.9913C87.0836 17.9913 84.6605 15.2833 83.7884 15.4492C82.9163 15.6151 81.7257 17.9913 81.7257 17.9913C81.7257 17.9913 74.5817 20.707 74.8794 23.4226C75.1771 26.1383 78.4514 39.3772 78.4514 39.3772C78.4514 39.3772 81.1303 55.3317 78.749 57.029C76.3677 58.7263 90.0603 63.1392 90.3579 61.1025C90.6556 59.0657 91.2509 38.6982 90.3579 35.6431C89.4649 32.588 87.0836 17.9913 87.0836 17.9913Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.5017 23.4226H101.182C101.182 23.4226 103.753 36.322 104.05 37.6798C104.348 39.0377 104.943 45.4874 104.646 45.4874C104.348 45.4874 98.3947 44.1296 98.3947 45.1479L97.5017 23.4226Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3773 55.3658H83.2869C81.9119 48.1523 81.797 41.1828 83.2869 34.524H97.3773C95.1034 41.063 94.9614 47.9848 97.3773 55.3658Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5583 46.5057L81.7256 48.5425C81.7256 48.5425 89.7626 49.9003 89.7626 46.1663C89.7626 42.4323 81.7256 44.469 81.7256 44.469L79.0465 43.4921L77.5583 46.5057Z",
    fill: "#A0616A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4512 21.3859L74.8792 22.4042L72.2003 40.3955C72.2003 40.3955 71.3073 45.1479 72.7956 45.4874C74.2839 45.8268 78.4512 48.5425 78.4512 48.5425C78.4512 48.5425 79.0465 43.4506 80.2372 43.4506L77.2605 40.735L79.0465 28.8539L78.4512 21.3859Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9365 56.1465H8.40527V56.4647H27.9365V56.1465Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9856 53.2828H13.7065V56.2261H13.9856V53.2828Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4956 53.2828H22.2166V56.2261H22.4956V53.2828Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7725 9.05383H15.2412V9.37203H34.7725V9.05383Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4712 9.29248H29.1921V12.2358H29.4712V9.29248Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9609 9.29248H20.6819V12.2358H20.9609V9.29248Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4431 40.396H34.9119V40.7142H54.4431V40.396Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1418 40.6346H48.8628V43.5779H49.1418V40.6346Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6318 40.6346H40.3528V43.5779H40.6318V40.6346Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.24 40.2369H1.70874V40.5551H21.24V40.2369Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9387 40.4755H15.6597V43.4188H15.9387V40.4755Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.42868 40.4755H7.14966V43.4188H7.42868V40.4755Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6775 24.3271H25.1462V24.6453H44.6775V24.3271Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7265 21.4634H30.4475V24.4067H30.7265V21.4634Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2368 21.4634H38.9578V24.4067H39.2368V21.4634Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2443_549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 125,
    height: 119,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/CartIcon.f61f5a7e0ac8ae2fb47a259a13b66675.svg";
export { ForwardRef as ReactComponent };